import React from 'react';

import SectionSeparator from '@dashboard/components/SectionSeparator';
import { SleepTimeUnits } from '@dashboard/generated/wp/platform';
import { AvTimerOutlined } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';

import useStepDefinitionsMutator from '../../useStepDefinitionsMutator';

export default function DelaySection() {
  const { fields } = useStepDefinitionsMutator();
  const isPresent = fields.value.find((k) => Boolean(k.sleep));

  if (isPresent) {
    return null;
  }

  const onAddClick = () => {
    fields.insert(0, {
      disabled: false,
      sleep: {
        timeAmount: 1,
        timeUnit: SleepTimeUnits.Minutes,
      },
    });
  };

  return (
    <>
      <SectionSeparator />
      <Stack direction="row" justifyContent="center">
        <Button startIcon={<AvTimerOutlined />} size="small" variant="contained" color="secondary" onClick={onAddClick}>
          Add delay
        </Button>
      </Stack>
    </>
  );
}
